var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action } from 'mobx';
import { api } from 'helpers/Api';
import { ReceiptLayout } from './Model';
export default class default_1 {
    constructor() {
        this.data = [];
        this.loaded = false;
        this.set = (values) => {
            this.data = values.map((item) => new ReceiptLayout(item));
            this.loaded = true;
        };
        this.push = (value) => {
            this.data.push(new ReceiptLayout(value));
        };
        this.replace = (value) => {
            this.data.splice(this.data.findIndex(f => f.id === value.id), 1, value);
        };
    }
    read(id) {
        console.log('ReceiptLayouts/Store - read');
        if (id)
            return api.get('receiptlayouts' + id);
        return api.get('receiptlayouts').then((value) => {
            // console.log('receiptLayouts', value)
            this.set(value);
            return value;
        });
    }
    create(value) {
        return api.post('receiptlayouts', value).then(this.push);
    }
    update(id, value) {
        return api.put('receiptlayouts/' + id, value).then(this.replace);
    }
}
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);
__decorate([
    action
], default_1.prototype, "replace", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/ReceiptLayouts/Store.ts
// module id = 348
// module chunks = 0